module.exports = __webpack_public_path__ + "static/media/RestlessLeg.32b99094.png";